module.exports = __webpack_public_path__ + "static/media/pegasus.27f2c4d9.svg";